import styled from 'styled-components'

export const ZonesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`

export const ZoneCount = styled.span`
  margin-left: ${({ theme }) => theme.spacing.small};
`
